import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllUsers(_obj, params) {
    const res = await axios.get('api/users/', { params });
    return res.data;
  },
  async getUser(_obj, id) {
    const res = await axios.get(`api/users/${id}/`);
    return res.data;
  },
  async createUser(_obj, data) {
    const res = await axios.post('api/users/', data);
    return res.data;
  },
  async updateUser(_obj, { id, data }) {
    const res = await axios.patch(`api/users/${id}/`, data);
    return res.data;
  },
};

export const user = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
